import React, { useContext } from "react";
import { MiscContext } from "components/MiscProvider";

export default function useDevice() {
  const { device } = useContext(MiscContext);

  const isMobile = device === "mobile";
  const isTablet = device === "tablet";
  const isDesktop = device === "desktop";

  return { device, isMobile, isTablet, isDesktop };
}
